// Old frontend cert metrics only accepted these 3 keys — no date range.
// Chart counts and drilldown counts must use the same filter scope.
export const CERT_METRICS_FILTER_KEYS = [
  'supplierCompanyIds',
  'collaborationStatusIds',
  'standardIds',
] as const;

export function stripCertMetricsFilter(rawFilter: string): string {
  try {
    const parsed = JSON.parse(rawFilter) as Record<string, unknown>;
    const filtered = CERT_METRICS_FILTER_KEYS.reduce<Record<string, unknown>>(
      (acc, key) => {
        if (Object.hasOwn(parsed, key)) acc[key] = parsed[key];
        return acc;
      },
      {},
    );
    return JSON.stringify(filtered);
  } catch {
    return '{}';
  }
}
